<div class="container-fluid">
  <div class="footer-container">
    <div class="row">
      <div class="col small">
        Copyright &copy; {{ currentYear }} Thorough Repository Pty Ltd. All Rights
        Reserved.
      </div>
      <div class="col">
        <div class="flex justify-content-end">
          <a
            class="pointer cursor-pointer me-3 text"
            (click)="openTermsConditionsPopup()"
            >Terms & Conditions</a
          >

          <a
            class="pointer cursor-pointer text"
            (click)="openPrivacyPolicyPopup()"
            >Privacy Policy</a
          >
        </div>
      </div>
    </div>
  </div>
</div>
